import { all } from 'redux-saga/effects'

import empresaSaga from '@mec/stores/empresa/empresa.saga'

export default function* sagas(): any {
  yield all([...empresaSaga])
}
